var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaylater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "earth",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 216",
    enableBackground: "new 0 0 256 216",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.238,2.307H68.807c-5.896,0-10.648,4.4-10.648,9.812v72.069C58.159,89.6,62.911,94,68.807,94h106.388 c5.896,0,10.648-4.4,10.648-9.812V12.119C185.886,6.707,181.134,2.307,175.238,2.307z M176.25,82.956c0,0.66-0.616,1.232-1.32,1.232 H69.115c-0.748,0-1.32-0.572-1.32-1.232V48.154H176.25V82.956z M176.25,21.931H67.795v-8.58c0-0.66,0.616-1.232,1.32-1.232h105.772 c0.748,0,1.32,0.572,1.32,1.232v8.58H176.25z M76.99,67.293h22.263v8.712H76.99V67.293z M107.921,67.293h32.207v8.712h-32.207 V67.293z M229.943,83.553L186.57,124.68c1.092,2.644,1.59,5.874,1.257,8.89c-0.286,6.278-2.86,12.262-7.262,16.742 c-4.505,4.306-10.593,6.727-16.974,6.267l-59.452-2.005c-2.81,0.015-4.599-2.217-4.512-4.854c0.088-2.636,2.217-4.599,4.679-4.409 l59.626,1.902c7.806,0.088,14.369-5.903,14.735-13.638c0.365-7.734-5.903-14.369-13.638-14.735l-74.161-2.245 c-12.175-0.327-25.024,1.389-31.897,12.028L2,213.693h56.623l18.808-24.781c4.331-4.203,10.522-6.45,16.974-6.267l51.615,1.465 c12.627,0.295,24.771-4.999,32.982-13.373l70.507-66.788c5.622-5.2,6.169-14.217,0.486-20.258 C244.549,78.449,235.738,78.25,229.943,83.553z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaylater);
export default __webpack_public_path__ + "static/media/paylater.51c486ea2c352cf8ca6e75b50c24cc9d.svg";
export { ForwardRef as ReactComponent };